import Base from '@studiometa/js-toolkit';
import { isDev } from '../config';

/**
 * GoToTab class
 */
export default class GoToTab extends Base {
  /**
   * Config
   */
  get config() {
    return {
      name: 'GoToTab',
      log: isDev(),
      tab: false,
      getLabel: false,
    };
  }

  /**
   * Update the component's content when there is a tab change.
   */
  mounted() {
    if (this.$options.getLabel && this.$parent.tabNav.nextTab) {
      this.$parent.tabNav.$on('tabChange', this.updateContent);
    }
  }

  /**
   * Unbind the tabChange event from the parent.
   */
  destroyed() {
    if (this.$options.getLabel && this.$parent.tabNav.nextTab) {
      this.$parent.tabNav.$off('tabChange', this.updateContent);
    }
  }

  /**
   * Update the content of the component from the tabNav `nextTab` element.
   * @see TabNav.js
   */
  updateContent() {
    if (this.$parent.tabNav.nextTab) {
      if (this.$refs.nextLabel) {
        this.$refs.nextLabel.innerHTML = this.$parent.tabNav.nextTab.innerHTML;
      } else {
        this.$el.innerHTML = this.$parent.tabNav.nextTab.innerHTML;
      }
    }
  }

  /**
   * Switch tab on click:
   * - either go to the defined tab if it is set
   * - or go to the next tab
   *
   * @param {MouseEvent} e The event's object.
   */
  onClick(e) {
    if (this.$options.tab) {
      const { hash } = this.$el;
      if (hash) {
        e.preventDefault();
      }
      this.$parent.tabNav.goTo(this.$options.tab, hash);
      return;
    }

    this.$parent.tabNav.next();
  }
}
